import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Twitter, Linkedin, Mail } from "lucide-react";
import "./footer.css";

const Footer = () => {
  return (
    <footer className="lp-footer">
      <div className="footer-grid">
        <div className="footer-brand">
          <div className="lp-logo-text" style={{ marginBottom: '16px' }}>
            <img src={require('../assets/logo-full.png')} alt="FastInvoice" style={{ height: '120px', width: 'auto' }} />
          </div>
          <p>India's smartest invoicing & billing platform. Built for freelancers, SMEs, and enterprises who mean business.</p>
          <div className="footer-socials">
            <button className="social-btn" aria-label="Facebook"><Facebook size={18} /></button>
            <button className="social-btn" aria-label="Twitter"><Twitter size={18} /></button>
            <button className="social-btn" aria-label="Linkedin"><Linkedin size={18} /></button>
            <button className="social-btn" aria-label="Email"><Mail size={18} /></button>
          </div>
        </div>
        <div className="footer-col">
          <h4>Product</h4>
          <ul>
            <li><Link to="/#features">Features</Link></li>
            <li><Link to="/#pricing">Pricing</Link></li>
            <li><Link to="/#how-it-works">How It Works</Link></li>
            <li><Link to="/#faq">FAQ</Link></li>
          </ul>
        </div>
        <div className="footer-col">
          <h4>Company</h4>
          <ul>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/blog">Blog</Link></li>
            {/* <li><Link to="/careers">Careers</Link></li> */}
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>
        <div className="footer-col">
          <h4>Legal</h4>
          <ul>
            <li><Link to="/privacy-policy">Privacy Policy</Link></li>
            <li><Link to="/terms-of-service">Terms of Service</Link></li>
            <li><Link to="/refund-policy">Refund Policy</Link></li>
            {/* <li><Link to="/#security">Security</Link></li> */}
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <p>© 2026 FastInvoice.in · All rights reserved.</p>
        <div className="footer-links">
          <Link to="/privacy-policy">Privacy</Link>
          <Link to="/terms-of-service">Terms</Link>
          <Link to="/#sitemap">Sitemap</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
